import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, signal } from "@angular/core";
import { TypeManagerDecorator } from "../../../../main/type.map.service";
import { S25TableModule } from "../../../s25-table/s25.table.module";
import { Table } from "../../../s25-table/Table";
import { Budget } from "../Budget";
import { Bind } from "../../../../decorators/bind.decorator";
import { S25PricingUtil } from "../../../s25-pricing/s25.pricing.util";

@TypeManagerDecorator("s25-ng-budget-admin-requests")
@Component({
    selector: "s25-ng-budget-admin-requests",
    template: `
        <div class="requests-tab">
            <div class="section-header">
                <h3>Pending Budget Requests</h3>
                <!-- TODO: tie budgets into workflow -->
                <!--                <div class="header-actions">-->
                <!--                    <s25-ng-button-->
                <!--                        [type]="'primary'"-->
                <!--                        [buttonText]="'Approve Selected'"-->
                <!--                        [onClick]="approveSelectedRequests"-->
                <!--                        [isLoading]="isProcessingRequests()"-->
                <!--                        [disabled]="selectedRequests.length === 0"-->
                <!--                    ></s25-ng-button>-->
                <!--                    <s25-ng-button-->
                <!--                        [type]="'danger&#45;&#45;outline'"-->
                <!--                        [buttonText]="'Reject Selected'"-->
                <!--                        [onClick]="rejectSelectedRequests"-->
                <!--                        [isLoading]="isProcessingRequests()"-->
                <!--                        [disabled]="selectedRequests.length === 0"-->
                <!--                    ></s25-ng-button>-->
                <!--                </div>-->
            </div>

            @if (pendingRequests && pendingRequests.length > 0) {
                <s25-ng-table
                    [dataSource]="requestsTableData"
                    [hasRefresh]="true"
                    [hasFilter]="true"
                    [hasSelect]="true"
                    [hasSelectAll]="true"
                    [columnSortable]="true"
                    [hasTotalRowCount]="true"
                    [caption]="'Pending Budget Requests'"
                    (selectedChange)="onRequestsSelected($event)"
                ></s25-ng-table>
            } @else {
                <div class="no-requests">
                    <p>No pending budget requests for {{ selectedFiscalYear }}</p>
                </div>
            }
        </div>
    `,
    styles: `
        .requests-tab {
            background: white;
            border-radius: 8px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            overflow: hidden;
        }

        .section-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 1.5rem;
            background: #f8f9fa;
            border-bottom: 1px solid #e5e5e5;
        }

        .section-header h3 {
            margin: 0;
            font-size: 1.2rem;
            color: #333;
            font-weight: 600;
        }

        .header-actions {
            display: flex;
            gap: 1rem;
            align-items: center;
        }

        .no-requests {
            text-align: center;
            padding: 3rem;
            color: #666;
        }

        @media (max-width: 768px) {
            .section-header {
                flex-direction: column;
                gap: 1rem;
                align-items: stretch;
            }
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [S25TableModule],
})
export class BudgetAdminRequestsComponent {
    @Input() pendingRequests: Budget.BudgetRequest[] = [];
    @Input() selectedFiscalYear: string = "";
    @Output() requestsProcessed = new EventEmitter<void>();

    isProcessingRequests = signal<boolean>(false);
    selectedRequests: number[] = [];

    requestsTableData: Table.DataSource = {
        type: "paginated",
        dataSource: this.getRequestsTableRows,
        defaultPageSize: 25,
        pageSizes: [10, 25, 50, 100],
        columns: [
            {
                id: "organizationName",
                header: "Organization",
                minWidth: 200,
                cells: { text: "", className: "font-weight-medium" },
            },
            {
                id: "requestedAmount",
                header: "Requested Amount",
                minWidth: 150,
                align: "right",
                cells: { text: "", className: "currency-amount" },
            },
            {
                id: "requestDate",
                header: "Request Date",
                minWidth: 120,
                cells: { text: "" },
            },
            {
                id: "description",
                header: "Description",
                minWidth: 250,
                cells: { text: "" },
            },
            {
                id: "actions",
                header: "Actions",
                minWidth: 200,
                align: "center",
                cells: { text: "" },
            },
        ],
    };

    @Bind
    async getRequestsTableRows(params: Table.PaginatedQuery): Promise<Table.DataSourceResponse> {
        const pageSize = params.pageSize || 25;
        const currentPage = params.page || 1;
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;

        // Get the paginated slice of requests
        const paginatedRequests = this.pendingRequests.slice(startIndex, endIndex);
        console.log("Paginated Requests:", paginatedRequests);

        const rows: Table.Row[] = paginatedRequests.map((request) => ({
            id: request.requestId,
            name: request.organizationName,
            data: request,
            cells: {
                organizationName: { text: request.organizationName },
                requestedAmount: {
                    text: S25PricingUtil.formatCurrency(request.requestedAmount, request.currency || "USD"),
                },
                requestDate: {
                    text: new Date(request.requestDate).toLocaleDateString(),
                },
                description: { text: request.description || "N/A" },
                actions: { text: "Approve | Reject" },
            },
        }));

        return {
            rows,
            totalRows: this.pendingRequests.length, // Total count for pagination
        };
    }

    onRequestsSelected(selectedIds: number[]): void {
        this.selectedRequests = selectedIds;
    }
}
